import { skipToken } from "@reduxjs/toolkit/query";
import type EntityMember from "_shared/entity-members/entity-member";
import { useGetIndividualsByUserIdsQuery } from "marketplace/individuals/_api/individual-api";
import Individual from "marketplace/individuals/individual";

/**
 * The person a Submit would reach, as the directory knows them, for the submit dialog to name them and
 * open their business card (#5813).
 *
 * Called by the page rather than by the dialog, so the lookup starts when the page renders and the
 * name is usually there by the time the leader presses Submit. It is the same by-user-id lookup the
 * Details tab names the Client Representative through, so the answer is often already cached.
 *
 * Undefined while the lookup runs, when it fails, and when there is nobody to name; the dialog then
 * names the party alone, which is still true. A submission never waits on a display name.
 */
export default function useProposalSubmitRecipient(
  recipient: EntityMember | undefined,
): Individual | undefined {
  const recipientUserId = recipient?.userId.value;
  const { data } = useGetIndividualsByUserIdsQuery(
    recipientUserId ? { userIds: [recipientUserId] } : skipToken,
  );
  if (!recipientUserId) return undefined;

  const individual = Individual.fromJSON(data?.find((candidate) => candidate.userId === recipientUserId));
  return individual?.fullName.trim() ? individual : undefined;
}
